import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/approvals")({
  component: () => <Outlet />,
});
